package dev.jfronny.zerointerest.db

import androidx.room3.EntityInsertAdapter
import androidx.room3.RoomDatabase
import androidx.room3.coroutines.createFlow
import androidx.room3.util.getColumnIndexOrThrow
import androidx.room3.util.performSuspending
import androidx.sqlite.SQLiteStatement
import de.connect2x.trixnity.core.model.UserId
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.Map
import kotlin.collections.MutableList
import kotlin.collections.mutableListOf
import kotlin.reflect.KClass
import kotlinx.coroutines.flow.Flow

@Suppress(names = ["UNCHECKED_CAST", "DEPRECATION", "REDUNDANT_PROJECTION", "REMOVAL", "MemberExtensionConflict"])
internal class TransactionTemplateDao_Impl(
  __db: RoomDatabase,
) : TransactionTemplateDao {
  private val __db: RoomDatabase

  private val __insertAdapterOfTransactionTemplateEntity:
      EntityInsertAdapter<TransactionTemplateEntity>

  private val __zeroInterestTypeConverters: ZeroInterestTypeConverters =
      ZeroInterestTypeConverters()
  init {
    this.__db = __db
    this.__insertAdapterOfTransactionTemplateEntity = object : EntityInsertAdapter<TransactionTemplateEntity>() {
      protected override fun createQuery(): String = "INSERT OR REPLACE INTO `TransactionTemplateEntity` (`roomId`,`id`,`description`,`sender`,`receivers`) VALUES (?,?,?,?,?)"

      protected override fun bind(statement: SQLiteStatement, entity: TransactionTemplateEntity) {
        statement.bindText(1, entity.roomId)
        statement.bindText(2, entity.id)
        statement.bindText(3, entity.description)
        statement.bindText(4, entity.sender)
        val _tmp: String = __zeroInterestTypeConverters.fromReceivers(entity.receivers)
        statement.bindText(5, _tmp)
      }
    }
  }

  public override suspend fun insert(entity: TransactionTemplateEntity): Unit = performSuspending(__db, false, true) { _connection ->
    __insertAdapterOfTransactionTemplateEntity.insert(_connection, entity)
  }

  public override fun getTemplates(roomId: String): Flow<List<TransactionTemplateEntity>> {
    val _sql: String = "SELECT * FROM TransactionTemplateEntity WHERE roomId = ?"
    return createFlow(__db, false, arrayOf("TransactionTemplateEntity")) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        val _columnIndexOfRoomId: Int = getColumnIndexOrThrow(_stmt, "roomId")
        val _columnIndexOfId: Int = getColumnIndexOrThrow(_stmt, "id")
        val _columnIndexOfDescription: Int = getColumnIndexOrThrow(_stmt, "description")
        val _columnIndexOfSender: Int = getColumnIndexOrThrow(_stmt, "sender")
        val _columnIndexOfReceivers: Int = getColumnIndexOrThrow(_stmt, "receivers")
        val _result: MutableList<TransactionTemplateEntity> = mutableListOf()
        while (_stmt.step()) {
          val _item: TransactionTemplateEntity
          val _tmpRoomId: String
          _tmpRoomId = _stmt.getText(_columnIndexOfRoomId)
          val _tmpId: String
          _tmpId = _stmt.getText(_columnIndexOfId)
          val _tmpDescription: String
          _tmpDescription = _stmt.getText(_columnIndexOfDescription)
          val _tmpSender: String
          _tmpSender = _stmt.getText(_columnIndexOfSender)
          val _tmpReceivers: Map<UserId, Long>
          val _tmp: String
          _tmp = _stmt.getText(_columnIndexOfReceivers)
          _tmpReceivers = __zeroInterestTypeConverters.toReceivers(_tmp)
          _item = TransactionTemplateEntity(_tmpRoomId,_tmpId,_tmpDescription,_tmpSender,_tmpReceivers)
          _result.add(_item)
        }
        _result
      } finally {
        _stmt.close()
      }
    }
  }

  public override suspend fun delete(roomId: String, id: String) {
    val _sql: String = "DELETE FROM TransactionTemplateEntity WHERE roomId = ? AND id = ?"
    return performSuspending(__db, false, true) { _connection ->
      val _stmt: SQLiteStatement = _connection.prepare(_sql)
      try {
        var _argIndex: Int = 1
        _stmt.bindText(_argIndex, roomId)
        _argIndex = 2
        _stmt.bindText(_argIndex, id)
        _stmt.step()
      } finally {
        _stmt.close()
      }
    }
  }

  public companion object {
    public fun getRequiredColumnConverters(): List<KClass<*>> = emptyList()

    public fun getRequiredDaoReturnTypeConverters(): List<KClass<*>> = emptyList()
  }
}
